export default function Protocol() {
    return (
        <div className="page" style={{padding: '0 10px'}}>
            <h3>快背中医隐私政策</h3>
            <p></p>
            <p>更新日期：2025年5月14日</p>
            <p>生效日期：2024年6月10日</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;我们（以下简称“我们”）作为本应用的运营者，我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维护您对我们的信任，恪守以下原则，保护您的个人信息：权责一致、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;请在使用我们产品前，仔细阅读《隐私声明》。其中，有关您个人信息权益的条款等重要内容我们已用加粗形式提示，请特别关注。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;如您未明示同意本隐私声明，我们无法为您提供完整的产品和服务，您也可以选择停止使用。当您选择继续或再次使用时，基于提供产品和服务所必需，将视为您接受和认可我们按照本声明对您的相关信息进行处理。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;本应用尊重并保护所有使用服务用户的个人隐私权。为了给您提供更为完善的产品服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。
                您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本应用服务使用协议不可分割的一部分。</p>
            <p>&nbsp;</p>
            <p>1.信息收集</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(a)
                在您使用本应用的服务，本应用自动接收并记录的您的设备上的信息，包括您的IP地址、设备类型、系统语言、访问日期和时间、读写SD卡数据。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(b) 我们的产品集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android
                ID/IDFA/OPENUDID/GUID/IP地址/SIM 卡 IMSI
                信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。</p>
            <p>2.信息使用</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(a)
                本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(b)
                本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。</p>
            <p></p>
            <p>3.信息披露</p>
            <p>在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(a) 经您事先同意，向第三方披露；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(c)
                根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(d)
                如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(e)
                如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(f) 其它本应用根据法律、法规或者网站政策认为合适的披露c。</p>
            <p></p>
            <p>4.第三方SDK名称及使用方式、目的、范围</p>
            <p></p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;为保障App相关功能的实现与应用安全稳定的运行，我们也可能会接入由第三方提供的软件开发包（SDK）实现相关目的。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全评估，以保护您的个人信息安全。我们对接入的相关第三方SDK同时在以下清单中列明，您可以通过本清单中提供的链接或者路径查看第三方的数据使用和保护规则。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;请注意，第三方SDK可能由于版本升级、策略调整等原因导致其个人信息处理类型发生变化，请以其公示的官方说明为准。</p>
            &nbsp;
            <p><b>接入第三方SDK目录：</b></p>
            <p><b>SDK名称：穿山甲广告SDK</b></p>
            <p><b>使用目的：展示广告</b></p>
            <p><b>使用场景：在app内展示广告、广告监测归因、反作弊</b></p>
            <p><b>Android端收集的个人信息：</b>设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间、AndroidID、OAID、设备MAC地址、设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、硬件序列号build_serial，具体字段因软硬件版本不同而存在差异）、运营商信息、Wi-Fi状态、网络信号强度、IP地址、应用包名、运行中的进程信息、版本号、应用前后台状态、软件列表信息、线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器、粗略位置信息（WiFi列表、WLAN接入点（如SSID，BSSID）、基站）、对广告的展示、点击及转化等交互数据、崩溃数据、性能数据
            </p>
            <p><b>ios端收集的个人信息：</b>设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间、手机系统重启时间、磁盘总空间、系统总内存空间、IDFV、设备MAC地址、设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）、运营商信息、Wi-Fi状态、网络信号强度、IP地址、加速度传感器、陀螺仪传感器、对广告的展示、点击及转化等交互数据、崩溃数据、性能数据
            </p>
            <p><b>共享方式：SDK本机采集</b></p>
            <p><b>第三方机构名称：北京巨量引擎网络技术有限公司</b></p>
            <p><b>隐私政策链接：</b><a
                href="https://www.csjplatform.com/privacy/partner">https://www.csjplatform.com/privacy/partner</a>
            </p>
            &nbsp;
            <p><b>SDK名称：微信OpenSDK</b></p>
            <p><b>使用目的：跳转广告、打开微信客服</b></p>
            <p><b>使用场景：跳转微信小程序/小游戏广告、帮助用户在App内跳转至微信客服</b></p>
            <p><b>Android端收集的个人信息：</b>微信头像、昵称信息、微信支付订单标识、图片或内容、应用进程信息、读指定包名
            </p>
            <p><b>ios端收集的个人信息：</b>应用包名、拟分享的图片或内容、微信头像、微信昵称、微信支付订单号、剪切板权限
            </p>
            <p><b>共享方式：SDK本机采集</b></p>
            <p><b>第三方机构名称：深圳市腾讯计算机系统有限公司</b></p>
            <p><b>隐私政策链接：</b><a
                href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a>
            </p>
            &nbsp;
            <p><b>SDK名称：友盟+移动统计SDK</b></p>
            <p><b>使用目的：App统计分析</b></p>
            <p><b>使用场景：App统计分析</b></p>
            <p><b>Android端收集的个人信息：</b>OAID、Android ID、读指定包名、读写SDCard、运营商信息
            </p>
            <p><b>ios端收集的个人信息：</b>OAID、Android ID、读指定包名、读写SDCard、运营商信息
            </p>
            <p><b>共享方式：SDK本机采集</b></p>
            <p><b>第三方机构名称：友盟同欣（北京）科技有限公司</b></p>
            <p><b>隐私政策链接：</b><a
                href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a>
            </p>
            &nbsp;
            <p><b>SDK名称：巨量引擎转化SDK</b></p>
            <p><b>涉及个人信息:</b>1、设备信息：【双端】IPV4、IPV6、UA、本地时间、应用内用户唯一ID；【仅Android】AndroidID、IMEI、OAID、设备品牌、型号、操作系统、软件系统版本、分辨率、网络访问模式、设备语言、MCC移动国家码、MNC移动网络码、CPU信息、浏览器的类型和版本号、操作、使用、服务日志等基础信息、WiFi路由器MAC地址(BSSID)、设备的MAC地址(如为iOS端，则仅适用于IOS3200以下版本)、设备标识符(如IMSI、ICCID、GAID(仅GMS服务)、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异)；【仅IOS】IDFV、系统更新时间、设备名称、设备machine(device_model)、Hardware model、系统启动时间(秒)、系统版本、物理内存大小、硬盘大小、硬盘挂载id、设备初始化时间、tun、anpi、IDFA 2、应用信息：【双端】开发者应用名、应用包名、运行中的进程信息、应用版本号、SDK版本号、应用前后台状态；【仅Android】WIFI状态、软件列表信息 3、广告信息：【双端】对广告的展示、点击及激活等交互数据 4、位置信息：【双端】读取设备IP、位置信息 5、性能数据：【双端】如崩溃数据、性能数据 6、其他信息：【仅Android】运营商信息、设备时区、sim卡信息
            </p>
            <p><b>使用目的：</b>1、保障软件与服务安全运行； 2、广告投放、反作弊； 3、广告检测归因、统计分析
            </p>
            <p><b>使用场景：</b>打开APP时
            </p>
            <p><b>采集方式：</b>sdk
            </p>
            <p><b>合作方主体：</b>北京巨量引擎网络技术有限公司
            </p>
            <p><b>合作方隐私链接：</b><a
                href="https://bytedance.larkoffice.com/docx/PfdrdczIHo0wjex3Qwdce5wYnzh">https://bytedance.larkoffice.com/docx/PfdrdczIHo0wjex3Qwdce5wYnzh</a>
            </p>
            <p><b>合作方官网链接：</b><a
                href="http://www.chinatelecom.com.cn/">http://www.chinatelecom.com.cn/</a>
            </p>
            &nbsp;
            <p></p>
            <p>5.未成年人条款</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;我们非常重视对未成年个人信息的保护。我们主要面向成年人。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;若您是未满18周岁的未成年人，在使用各项服务前，应在您的父母或其他监护人的监护、指导下共同阅读并同意本指引及《用户协议》。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;若您是未满14周岁的未成年人的监护人，在使用我们的各项服务前，应为您的被监护人阅读并同意本指引。未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，您应在取得监护人的同意以及在监护人指导下正确使用相关服务。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用或披露未成年人的个人信息；如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有其他疑问时，请通过公司本指引公示的联系方式与我们联系。</p>
            <p></p>
            <p>6.信息存储和交换</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本应用收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>
            <p></p>
            <p>7.本隐私政策的更改</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(a)如果决定更改隐私政策，本应用会在本政策中、本公司网站中以及本应用认为适当的位置发布这些更改，以便您了解本应用如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下本应用会透露这些信息。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;(b)本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。</p>
            <p></p>
            <p>8.如何联系我们</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;如果您对本隐私政策有任何疑问、意见或建议，您可以将相关内容发送至：1667469187@qq.com。我们收到您的问题后，将在十五个工作日内对您反馈的问题进行处理并及时向您答复。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;开发者名称：<b>重庆沃可达科技有限公司</b></p>
        </div>
    );
}
